// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1yA8T","rootSmall":"AddTileButton_rootSmall__3VJvm"};